import { useMemo } from 'react';

function clampNumber(value) {
  if (value === null || value === undefined) return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}

function adsAgeBadge(days) {
  const d = clampNumber(days);
  if (d === null) return { label: 'No disponible', tone: 'neutral' };
  if (d < 30) return { label: 'Saludable', tone: 'good' };
  if (d < 50) return { label: 'Requiere atención', tone: 'warn' };
  return { label: 'Renovación necesaria', tone: 'bad' };
}

function adSpendConcentrationBadge(label) {
  const s = String(label || '').toLowerCase();
  if (s === 'saludable') return { label: 'Saludable', tone: 'good' };
  if (s === 'requiere_atencion') return { label: 'Requiere atención', tone: 'warn' };
  return { label: 'No disponible', tone: 'neutral' };
}

function campaignConcentrationBadge(label) {
  const s = String(label || '').toLowerCase();
  if (s === 'saludable') return { label: 'Saludable', tone: 'good' };
  if (s === 'requiere_atencion') return { label: 'Requiere atención', tone: 'warn' };
  if (s === 'concentracion_alta') return { label: 'Concentración alta', tone: 'bad' };
  return { label: 'No disponible', tone: 'neutral' };
}

export default function useHomeAccountHealth({ homeSummary }) {
  const checks = useMemo(() => {
    const health = homeSummary?.health || {};

    // 1) Concentración de inversión por anuncio (desde homeSummary.health.ad_spend_concentration)
    const adConc = health?.ad_spend_concentration || null;
    const topSharePct = clampNumber(adConc?.top_share_pct);
    const recommendedMaxPct = clampNumber(adConc?.recommended_max_pct);
    const topAdName = adConc?.top_ad?.ad_name ? String(adConc.top_ad.ad_name) : null;

    const adSpendConcentration = {
      ...adSpendConcentrationBadge(adConc?.label),
      value:
        topSharePct == null
          ? null
          : `${Math.round(topSharePct)}%${recommendedMaxPct == null ? '' : ` (recomendado ≤ ${Math.round(recommendedMaxPct)}%)`}${
              topAdName ? ` · ${topAdName}` : ''
            }`,
    };

    // 2) Anuncios activos
    const activeAds = clampNumber(health?.active_ads);
    const activeAdsRow = {
      label: activeAds == null ? 'No disponible' : `${Math.round(activeAds)}`,
      tone: 'neutral',
      value: activeAds == null ? null : 'Anuncios con gasto (7 días)',
    };

    // 3) Edad de anuncios (weighted avg)
    const weightedAge = clampNumber(health?.ads_age?.weighted_avg_age);
    const adsAge = {
      ...adsAgeBadge(weightedAge),
      value: weightedAge == null ? null : `${Math.round(weightedAge)} días (promedio ponderado)`,
    };

    // 4) Concentración de campaña (homeSummary.campaign_concentration.top_share * 100)
    const campConc = homeSummary?.campaign_concentration || null;
    const campTopShare = clampNumber(campConc?.top_share);
    const campName = campConc?.top_campaign?.campaign_name ? String(campConc.top_campaign.campaign_name) : null;
    const campaignConcentration = {
      ...campaignConcentrationBadge(campConc?.label),
      value:
        campTopShare == null
          ? null
          : `${Math.round(campTopShare * 100)}%${campName ? ` · ${campName}` : ''}`,
    };

    return {
      adSpendConcentration,
      activeAds: activeAdsRow,
      adsAge,
      campaignConcentration,
    };
  }, [homeSummary]);

  return { checks };
}

